
//listen for other SRS app opened, close other opened tab if opened by script else set to blankpage 
export function isOtherTabOpen(fromRoute, page) {
    const onLocalStorageEvent = function(e){
            if(e.key === "openpages"){
         
            localStorage.page_available = Date.now();
        }
    };

    window.addEventListener('storage', onLocalStorageEvent);

    let lastSeen = localStorage.page_available || null;

    setInterval(function(){
        const current = localStorage.page_available || null;
       
        if(current !== lastSeen){
            lastSeen = current;
     
            if(!/acceptredirect/.test(window.location.pathname)){
                alert('SRS is open in another tab, please close first!')
                window.close()
                window.location.replace('about:blank');
            }
     
        }
    }, 500);
}
 